import { FlexAligner } from '@scaleaq/scaleui';
import { useTranslation } from 'react-i18next';

import { SummaryCard } from '@/components/card/summaryCard';
import { GraphAggregated, GraphBoxPlot, GraphHistogram, GraphLine, GraphScatter } from '@/icons';
import { colors, responsive } from '@/utils';

import { PlotType } from '../../types.ts';

const fillColor = colors.background.info.solid[100];
const iconWidth = '6rem';

export const ChartTypePicker = ({ onClick }: { onClick: (plotType: PlotType) => void }) => {
  const { t } = useTranslation(['chartConfig']);

  return (
    <FlexAligner gap={responsive.spacing['3xlarge']}>
      <SummaryCard
        Icon={<GraphLine fillColor={fillColor} width={iconWidth} />}
        title={t('linear.title')}
        summaryInfo={t('linear.summaryInfo')}
        onClick={() => onClick(PlotType.LINEAR)}
      />
      <SummaryCard
        title={t('linear.aggregatedChartTitle')}
        onClick={() => onClick(PlotType.AGGREGATED)}
        Icon={<GraphAggregated fillColor={fillColor} width={iconWidth} />}
      />
      <SummaryCard
        Icon={<GraphScatter fillColor={fillColor} width={iconWidth} />}
        title={t('scatterPlot.title')}
        summaryInfo={t('scatterPlot.summaryInfo')}
        onClick={() => onClick(PlotType.SCATTER)}
      />
      <SummaryCard
        title={t('boxPlot.title')}
        onClick={() => onClick(PlotType.BOXPLOT)}
        Icon={<GraphBoxPlot fillColor={fillColor} width={iconWidth} />}
      />
      <SummaryCard
        title={t('histogram.title')}
        onClick={() => onClick(PlotType.HISTOGRAM)}
        Icon={<GraphHistogram fillColor={fillColor} width={iconWidth} />}
      />
    </FlexAligner>
  );
};
